import React from 'react';
import Box from '@rsos/components/capstone/base/Box';
import Select from '@rsos/components/capstone/base/Select';
import { ErrorWrapper } from '@rsos/components/capstone/base/form/ErrorsWrapper';
import { InputTextLabel } from '@rsos/components/capstone/base/form/inputs/InputText/InputText.styles.js';

const AgencyNameSelect = ({ data, error, label, onChange, value }) => {
  const buildOption = agency => ({
    id: agency.id,
    label: agency.display_name,
    value: agency.display_name,
  });

  const customAgencyNameSelectStyles = {
    menuList: styles => ({
      ...styles,
      height: 150,
    }),
  };

  return (
    <Box data-name="agency-name">
      {label && (
        <InputTextLabel data-name="input-label" mb="3px" size="small">
          {label}
        </InputTextLabel>
      )}
      <Select
        onChange={onChange}
        options={data && data.map(buildOption)}
        noGap
        placeholder="Please type here&hellip;"
        styles={customAgencyNameSelectStyles}
        value={value}
      />
      {error ? <ErrorWrapper error={error} /> : null}
    </Box>
  );
};

export default AgencyNameSelect;
